/**
 * Feedback service
 * Provides typed functions for interacting with the feedback table
 */

import { supabase } from '../supabase';
import type { Feedback, FeedbackInsert } from '../types/database';

/**
 * Create a new feedback submission
 */
export async function createFeedback(feedback: FeedbackInsert) {
  const { data, error } = await supabase
    .from('feedback')
    .insert(feedback)
    .select()
    .single();

  if (error) {
    throw new Error(`Failed to create feedback: ${error.message}`);
  }

  return data as Feedback;
}

/**
 * Fetch all feedback submitted by the current user
 */
export async function getMyFeedback(
  userId: string | null | undefined
): Promise<Feedback[]> {
  if (!userId) {
    throw new Error('User must be authenticated to fetch feedback');
  }

  const { data, error } = await supabase
    .from('feedback')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) {
    throw new Error(`Failed to fetch feedback: ${error.message}`);
  }

  return data as Feedback[];
}

/**
 * Fetch all feedback (Admin only)
 */
export async function getAllFeedback() {
  const { data, error } = await supabase
    .from('feedback')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) {
    throw new Error(`Failed to fetch all feedback: ${error.message}`);
  }

  return data as Feedback[];
}
